import React from "react"
import classnames from "classnames"
import styles from "./BookServiceForm.less"
import { A, H5, P, Space, ServiceIcon, MaintenanceIcon } from "AtomicComponents"

class ServiceSummary extends React.PureComponent {
  render() {
    const {
      serviceType = "MSS",
      serviceData,
      serviceCode,
      asmc,
      vinRego,
      serviceSummaryDescription = "The total service price is the Base Scheduled Maintenance, plus any Additional Scheduled Maintenance items that are required.",
      isChangeItemsDisable
    } = this.props
    const scheduledMaintenance = []
    let totalPrice = 0
    serviceData.forEach((item) => {
      if (item.factoryCode === serviceCode) {
        totalPrice += item.basePrice
        scheduledMaintenance.push({
          description: item.factoryCodeEntity.description,
          price: item.basePrice
        })
      }
    })
    const additionalMaintenance = []
    serviceData.forEach((item) => {
      asmc.forEach((addtionalItemCode) => {
        if (item.factoryCode === addtionalItemCode) {
          totalPrice += item.basePrice
          additionalMaintenance.push({
            description: item.factoryCodeEntity.description,
            price: item.basePrice
          })
        }
      })
    })

    return (
      <div>
        <H5>SERVICE SUMMARY</H5>
        {serviceType === "MSS" && serviceSummaryDescription && (
          <P>{serviceSummaryDescription}</P>
        )}
        <div>
          <div className={classnames({
            [styles.ServiceSummary]: true
          })}>
            {serviceType !== "COMP" && (
              <ServiceIcon style={{ height: "20px", width: "20px", margin: "2px 16px 0 0" }} />
            )}
            <div style={{ flexGrow: 1 }}>
              {serviceType !== "COMP" && (
                <P withoutMargin>
                  <b>{serviceType === "MSS" ? "Base Scheduled Maintenance" : "Scheduled Maintenance"}</b>
                </P>
              )}
              <Space />
              {scheduledMaintenance.map((item, index) => (
                <P withoutMargin key={index}>
                  <span>{item.description}</span>
                  <span style={{ float: "right" }}>${item.price}</span>
                </P>
              ))}
            </div>
          </div>
          {additionalMaintenance.length > 0 && (
            <div>
              <div className={classnames({
                [styles.ServiceSummary]: true
              })}>
                <MaintenanceIcon style={{ height: "20px", width: "20px", margin: "2px 16px 0 0" }} />
                <div style={{ flexGrow: 1 }}>
                  <P withoutMargin><b>Additional Scheduled Maintenance</b></P>
                  <Space />
                  {additionalMaintenance.map((item, index) => (
                    <P withoutMargin key={index}>
                      <span>{item.description}</span>
                      <span style={{ float: "right" }}>${item.price}</span>
                    </P>
                  ))}
                </div>
              </div>
            </div>
          )}
          {!isChangeItemsDisable &&
            serviceType !== "COMP" && (
              <div style={{ textAlign: "right", margin: "1em 0" }}>
                <A
                  gtm={{
                    category: "Request A Service Form",
                    action: "Request A Service Form - Clicked \"EDIT SERVICE\""
                  }}
                  href={`/owners/servicing/owners-service-calculator/?factoryCode=${serviceCode}&VIN=${vinRego}${asmc &&
                    asmc.map(item => item && `&asmc=${item}`).join("")}`}>
                  Edit Service
                </A>
              </div>
            )}
        </div>
        <div className={classnames({
          [styles.ServiceSummaryPrice]: true
        })}>
          <H5 withDetails>TOTAL SERVICE PRICE</H5>
          <H5 withDetails>${totalPrice}</H5>
        </div>
      </div>
    )
  }
}

export default ServiceSummary



// WEBPACK FOOTER //
// ./src/AtomicContainers/BookServiceForm/ServiceSummary.jsx